import { render, staticRenderFns } from "./AddAvailableSpace.vue?vue&type=template&id=4c8ce05d&scoped=true"
import script from "./AddAvailableSpace.vue?vue&type=script&lang=js"
export * from "./AddAvailableSpace.vue?vue&type=script&lang=js"
import style0 from "./AddAvailableSpace.vue?vue&type=style&index=0&id=4c8ce05d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8ce05d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c8ce05d')) {
      api.createRecord('4c8ce05d', component.options)
    } else {
      api.reload('4c8ce05d', component.options)
    }
    module.hot.accept("./AddAvailableSpace.vue?vue&type=template&id=4c8ce05d&scoped=true", function () {
      api.rerender('4c8ce05d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/specialist-availability-calendar/components/availability-calendar/AddAvailableSpace.vue"
export default component.exports